import {
  eachDayOfInterval,
  getDate,
  getDay,
  getMonth,
  getYear,
} from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

const TOKYO_TIME_ZONE = 'Asia/Tokyo';

/**
 * 年月日を Asia/Tokyo の暦日として Date にする。
 */
export const createTokyoDate = (
  year: number,
  month: number,
  dayOfMonth: number
): Date =>
  zonedTimeToUtc(
    `${year}-${month.toString().padStart(2, '0')}-${dayOfMonth
      .toString()
      .padStart(2, '0')}T00:00:00`,
    TOKYO_TIME_ZONE
  );

/**
 * Date を Asia/Tokyo の年・月・日に分解する。
 */
export const getTokyoDateParts = (
  date: Date
): { year: number; month: number; dayOfMonth: number } => {
  const zonedDate = utcToZonedTime(date, TOKYO_TIME_ZONE);
  return {
    year: getYear(zonedDate),
    month: getMonth(zonedDate) + 1,
    dayOfMonth: getDate(zonedDate),
  };
};

/**
 * Date の Asia/Tokyo での曜日番号を返す。0 が日曜。
 * UTC 瞬間のまま getDay すると、実行環境のタイムゾーンで日付が前日にずれる。
 */
export const getTokyoWeekdayIndex = (date: Date): number =>
  getDay(utcToZonedTime(date, TOKYO_TIME_ZONE));

/**
 * eachDayOfIntervalのTZ考慮したwrapper関数
 *
 * eachDayOfIntervalが特定日の指定でTZの挙動が変わるため作成しています
 *
 * @link https://github.com/date-fns/date-fns/issues/2181
 */
export function eachDayOfIntervalInTimezone({
  start,
  end,
}: {
  start: Parameters<typeof utcToZonedTime>[0];
  end: Parameters<typeof utcToZonedTime>[0];
}) {
  const days = eachDayOfInterval({
    start: utcToZonedTime(start, TOKYO_TIME_ZONE),
    end: utcToZonedTime(end, TOKYO_TIME_ZONE),
  });

  return days.map((day) => zonedTimeToUtc(day, TOKYO_TIME_ZONE));
}
